<template>
  <div class="productAdvantageBlock">
    <div class="icon">
      <img :src="info.icon" />
    </div>
    <div class="l-center">
      <div class="subTitle">{{ info.subTitle }}</div>
    </div>
    <div class="title">{{ info.title }}</div>
    <div class="l-center">
      <div class="description">
        {{ info.description }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.productAdvantageBlock {
  &:hover {
    transform: translateY(-20px);
  }
  transition: all 0.5s;
  padding-top: 40px;
  width: 350px;
  height: 400px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 30px 0px rgba(11, 24, 67, 0.1);
  .icon {
    margin-bottom: 15px;
  }
  .subTitle {
    padding: 10px 20px;
    font-size: 12px;
    background-color: #fff;
    border-radius: 20px;
    color: #546792;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
  }
  .title {
    font-weight: bold;
    font-size: 28px;
    margin-top: 15px;
  }
  .description {
    margin-top: 15px;
    font-size: 18px;
    color: #999999;
    line-height: 34px;
    width: 280px;
  }
}
</style>
